import {
    useMemo,
    useEffect
} from 'react'
import { useSelector } from 'react-redux'

import {
    ThemeProvider,
    CssBaseline,
    createTheme
} from '@mui/material'
import {
    QueryClient,
    QueryClientProvider
} from '@tanstack/react-query'
import { CacheProvider } from '@emotion/react'
import { MethodsProvider } from '@shared/components/providers/Methods'
import { DialogsProvider } from '@shared/components/providers/Dialogs'

import createCache from '@emotion/cache'
import rtlPlugin from '@mui/stylis-plugin-rtl'
import { prefixer } from 'stylis'

import './style.css'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            retry: 2
        }
    }
})

export default function Providers({children}) {
    const mode = useSelector(s => s.mode)

    const cache = useMemo(() => createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin]
    }), [])

    const theme = useMemo(() => createTheme({
        direction: 'rtl',
        palette: {
            mode: mode,
            primary: { main: mode === 'dark' ? '#cddaed' : '#295781' },
        },
        typography: {
            fontFamily: "'Roboto', 'Noto Naskh Arabic', sans-serif",
        },
    }), [mode])

    useEffect(() => {
        document.body.dir = 'rtl'
    }, [])

    return (
        <CacheProvider value={cache}>
            <ThemeProvider theme={theme}>
                <CssBaseline enableColorScheme />
                <QueryClientProvider client={queryClient}>
                    <MethodsProvider>
                        <DialogsProvider>
                            {children}
                        </DialogsProvider>
                    </MethodsProvider>
                </QueryClientProvider>
            </ThemeProvider>
        </CacheProvider>
    )
}